/**
 * Returns a hash code from a string. NOT SECURE, meaning, don't use this to encrypt anything
 * important like user data or credit card numbers.  However, it is good enough for React's key=""
 * prop when iterating through arrays of simple strings.
 *
 * Example:
 * const errors = ['I am an api error response', 'I am another response']
 *
 * () => (
 * <ul className={s.errorTextList}>
 *   {errors?.map((error) => <li key={hashCode(error)}>{error}</li>)}
 * </ul>
 *
 * @param  {String} str The string to hash.
 * @return {Number}    A 32bit integer
 * @see http://werxltd.com/wp/2010/05/13/javascript-implementation-of-javas-string-hashcode-method/
 */
function hashCode(str: string): number {
  let hash = 0;
  for (let i = 0, len = str.length; i < len; i++) {
    const chr = str.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash |= 0; // Convert to 32bit integer
  }
  return hash;
}

export default hashCode;
